import Input from '@/components/forms/Input';
import { Translation } from '@/hoslog-intl';
import { useFormContext } from 'react-hook-form';
import { socialLinks } from './store-management.constant';

type StoreType = 'basic' | 'premium';
type StoreOrHost = 'store' | 'host';

export const SNS = ({
  storeOrHost = 'store',
  storeType = 'basic',
}: {
  storeOrHost?: StoreOrHost;
  storeType?: StoreType;
}) => {
  const { register } = useFormContext();

  const hiddenNames = new Set<string>([
    ...(storeOrHost === 'host' ? ['googleMap', 'website'] : []),
    ...(storeType === 'premium' ? ['googleMap', 'website'] : []),
  ]);

  const filteredLinks = socialLinks.filter((link) => !hiddenNames.has(link.name));

  return (
    <div className={`flex gap-5 sm:gap-10 md:gap-15 lg:gap-20 mt-6`}>
      <div className={`w-[200px] ${storeOrHost === 'store' ? 'xl:w-[245px]' : 'xl:w-[259px]'} shrink-0`}>
        <p className="text-base font-semibold whitespace-nowrap pl-12">
          <Translation id="storeManagement.form.sns" />
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4.5 w-full">
        {filteredLinks.map(({ id, label, name, placeholder }) => (
          <Input key={id} label={label} placeholder={placeholder} {...register(name)} />
        ))}
      </div>
    </div>
  );
};
